import type { IKeyboardsLanguages, IKeyboardsLayouts } from './models';

// TODO: Данный файл мигрировал из assr. Желательно отрефакторить его.

// prettier-ignore
export const keyboardsLayouts: IKeyboardsLayouts = {
    en: [
        // нижний регистр
        /* mac */ '§', /* win */ '`',
        'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '[', ']',
        'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ';', '\'', '\\',
        'z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/',
        // нижний регистр через shift
        /* mac */ '±', /* win */ '~',
        'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', '{', '}',
        'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', ':', '"', '|',
        'Z', 'X', 'C', 'V', 'B', 'N', 'M', '<', '>', '?',
        '@',
        ' ', '-', '_'
    ],
    ru: [
        // нижний регистр
        'ё', 'ё',
        'й', 'ц', 'у', 'к', 'е', 'н', 'г', 'ш', 'щ', 'з', 'х', 'ъ',
        'ф', 'ы', 'в', 'а', 'п', 'р', 'о', 'л', 'д', 'ж', 'э', 'ё',
        'я', 'ч', 'с', 'м', 'и', 'т', 'ь', 'б', 'ю', '/',
        // нижний регистр через shift
        'Ё', 'Ё',
        'Й', 'Ц', 'У', 'К', 'Е', 'Н', 'Г', 'Ш', 'Щ', 'З', 'Х', 'Ъ',
        'Ф', 'Ы', 'В', 'А', 'П', 'Р', 'О', 'Л', 'Д', 'Ж', 'Э', 'Ё',
        'Я', 'Ч', 'С', 'М', 'И', 'Т', 'Ь', 'Б', 'Ю', '?',
        '"',
        ' ', '-', '_'
    ]
};

/** regex для раскладок клавиатуры */
export const keyboardLanguages: IKeyboardsLanguages = {
    /* eslint-disable optimize-regex/optimize-regex */
    en: /[a-z[\]{};:'"\\|,.<>?§±`~]/i,
    ru: /[а-яё"/?]/i,
    /* eslint-enable optimize-regex/optimize-regex */
};

/**
 * Проверяет строку на совпадение с раскладкой клавиатуры.
 */
export function isKeyboardLayout(string: string, keyboardAlias: string): boolean {
    if (!string.length) return false;

    // your keyboard
    const keyboardLanguage: RegExp | undefined = keyboardLanguages[keyboardAlias];

    // недопустимая раскладка клавиатуры
    if (!keyboardLanguage) return false;

    let index = 0;

    let isValid = false;

    while (index < string.length) {
        const letter = string[index];

        if (keyboardLanguage.test(letter)) {
            isValid = true;

            return true;
        }

        index += 1;
    }

    return isValid;
}

/**
 * Конвертирует символы из одной раскладки в другую.
 */
export function keyboardSwitcher(characters = '', from = 'en', to = 'ru'): string {
    // incoming text string
    const textToConvert = characters;

    // if characters is empty stop working
    if (!textToConvert || !textToConvert.length) return '';

    // if incoming text and current keyboard not equal
    if (!isKeyboardLayout(textToConvert, from)) {
        return characters;
    }

    // current keyboard layout
    const locale = keyboardsLayouts[from];

    // convert characters to this keyboard layout
    const localeOn = keyboardsLayouts[to];

    let convertedText = '';

    let index = 0;

    while (index < textToConvert.length) {
        const letter = textToConvert[index];
        const letterIndex = locale.indexOf(letter);

        convertedText += localeOn[letterIndex];
        index += 1;
    }

    return convertedText;
}

export function switchToKeyboard(characters: string, keyboardAlias: string): string {
    const textToConvert = characters;

    if (!textToConvert.length) return '';

    const keyboards: string[] = Object.keys(keyboardLanguages);

    let index = 0;

    let convertedText = '';

    while (index < textToConvert.length) {
        const letter = textToConvert[index];

        let locale = '';

        keyboards.forEach(keyboardKey => {
            const isKeyboardIncludesLetter = isKeyboardLayout(letter, keyboardKey);

            if (isKeyboardIncludesLetter && keyboardKey !== keyboardAlias) {
                locale = keyboardKey;

                return '';
            }

            return '';
        });

        // TODO найти, как добраться тестами до кейса `locale === keyboardAlias ? letter`
        const returnedLetter =
            locale === keyboardAlias ? letter : keyboardSwitcher(letter, locale, keyboardAlias);

        convertedText += returnedLetter;
        index += 1;
    }

    return convertedText;
}

/**
 * Автоматически переводит английскую раскладку на русскую при вводе пользователем.
 */
export const formatToRussian = (value?: string): string => {
    if (!value) return '';

    // check user keyboard and if it needs convert to russian
    const enteredValue = switchToKeyboard(value, 'ru');
    // all profile names starts with uppercase symbol
    const formattedInputValue = enteredValue[0].toUpperCase() + enteredValue.substr(1);
    // clear value

    return formattedInputValue.replace(/[^\sа-яё-]/gi, '').replace(/\s{2,}/g, ' ');
};
